export enum SnackbarClassName {
  success = 'success-snackbar',
  error = 'error-snackbar',
  successUbs = 'success-snackbar-ubs',
  attention = 'attention-snackbar'
}
